import { Table, TableProps } from "antd";

interface AntdTableProps<T> extends TableProps<T> {
	columns: TableProps<T>["columns"];
	dataSource: TableProps<T>["dataSource"];
}

export function AntdTable<T>({
	columns,
	dataSource,
	...props
}: AntdTableProps<T>) {
	return (
		<>
			<Table
				rowKey={(record) => JSON.stringify(record)}
				columns={columns}
				dataSource={dataSource}
				size="large"
				bordered={true}
				{...props}
				pagination={
					props.pagination
						? {
								...props.pagination,
								size: "default",
								showSizeChanger: false,
							}
						: false
				}
				scroll={{
					...props.scroll,
					x: "max-content",
				}}
				onHeaderRow={() => ({
					style: {
						height: "56px",
					},
				})}
				onRow={(_, index) => ({
					style: {
						animationDelay: `${index! * 0.07}s`,
					},
					className: "animate-fade-in",
				})}
				// rowClassName={"!font-poppins"}
				// rootClassName="antd-table"
			/>
		</>
	);
}
